import React, { FC } from 'react';
import Lottie from 'react-lottie';
import animationData from '../../lotties/kiwi-logo.json';

export const Loader: FC<{ className?: string }> = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  return (
    <div className="min-h-30 flex items-center justify-center">
      <Lottie options={defaultOptions} height={100} width={100} />
    </div>
  );
};
